export enum EHardSurfaceType {
  Tile_Grout = 'Tile and Grout Cleaning',
  Vinyl_Plank_Tile = 'Vinyl Plank/Tile Cleaning',
  VCT_Tile = 'VCT Tile Maintenance',
  Sheet_Vinyl = 'Sheet Vinyl Cleaning',
}
